var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.W3cBookProductAccessibility = (function ($) {
    const WidgetSelector = '.js-accessibility-widget';
    const TabSelector = '.js-accessibility-tab';
    const PanelSelector = '.js-accessibility-panel';

    const ArrowLeftKey = 'ArrowLeft';
    const ArrowRightKey = 'ArrowRight';
    const HomeKey = 'Home';
    const EndKey = 'End';

    return {
        init: init
    };

    function init() {
        const $widgets = $(WidgetSelector);
        if (!$widgets.length) {
            return;
        }

        $widgets.each(function () {
            _collapseUnselectedPanels($(this));
        });

        $(document).on('click', TabSelector, _onTabClick);
        $(document).on('keydown', TabSelector, _onTabKeydown);
    }

    function _onTabClick(e) {
        const $tab = $(e.currentTarget);

        e.preventDefault();
        _selectTab($tab, _tabsIn(_widgetOf($tab)));
    }

    function _onTabKeydown(e) {
        const $tab = $(e.currentTarget);
        const $tabs = _tabsIn(_widgetOf($tab));
        const currentIndex = $tabs.index($tab);
        let nextIndex;

        if (e.key === ArrowRightKey) {
            nextIndex = (currentIndex + 1) % $tabs.length;
        } else if (e.key === ArrowLeftKey) {
            nextIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
        } else if (e.key === HomeKey) {
            nextIndex = 0;
        } else if (e.key === EndKey) {
            nextIndex = $tabs.length - 1;
        } else {
            return;
        }

        e.preventDefault();
        _selectTab($tabs.eq(nextIndex), $tabs).trigger('focus');
    }

    function _selectTab($tab, $tabs) {
        const selectedPanelId = $tab.attr('aria-controls');

        $tabs.each(function () {
            const $eachTab = $(this);
            const isSelected = $eachTab.attr('aria-controls') === selectedPanelId;

            $eachTab.attr('aria-selected', isSelected ? 'true' : 'false');
            $eachTab.attr('tabindex', isSelected ? '0' : '-1');
        });

        _panelsIn(_widgetOf($tab)).each(function () {
            const $panel = $(this);
            $panel.prop('hidden', $panel.attr('id') !== selectedPanelId);
        });

        return $tab;
    }

    function _collapseUnselectedPanels($widget) {
        const $tabs = _tabsIn($widget);
        const $selectedTab = $tabs.filter('[aria-selected="true"]').first();
        if (!$selectedTab.length) {
            return;
        }

        _selectTab($selectedTab, $tabs);
    }

    function _widgetOf($tab) {
        return $tab.closest(WidgetSelector);
    }

    function _tabsIn($widget) {
        return $widget.find(TabSelector);
    }

    function _panelsIn($widget) {
        return $widget.find(PanelSelector);
    }
})(jQuery);
